// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupUserItem__hint-d208c2 {
  margin-inline-end: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/GetParametersManager/components/PopupUserItem/PopupUserItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".hint {\n  margin-inline-end: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hint": `PopupUserItem__hint-d208c2`
};
module.exports = ___CSS_LOADER_EXPORT___;
